import React, { useEffect, useState } from 'react';
import { callApi } from '../../services/ApiServices';
import { useNavigate } from 'react-router-dom';
import CommonLoader from '../common/CommonLoader';
import { ImagePath } from '../common/ImagePath';
import { formatTimestamp } from '../../utlis/function';

const RecentOrders = () => {

  const [orders, setOrders] = useState([])
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const[loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const fetchRecentOrders = async () => {
    try {
      setLoading(true)
      let apiUrl = `admin/orders?page=1&limit=5`
      const res = await callApi({
        method: "get",
        url: apiUrl,
      }); 

      console.log("RECENT ORDERS --> ", res)
      setOrders(res.data)
    } catch (error) {
      console.log("Error fetching recent orders")
    }finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchRecentOrders();
  }, [])

  const getStatusColor = (color) => {
    const colors = {
      green: 'text-green-600',
      red: 'text-red-600',
      gray: 'text-gray-400',
    };
    return colors[color] || 'text-gray-600';
  };

  const getOrderStatus = (status) => {
  if (!status) return "Unknown";

  switch (status.toUpperCase()) {
    case "NOT_STARTED":
      return "Not Started";
    case "ACTIVE":
      return "Active";
    case "EXPIRED":
      return "Expired";
    case "CANCELLED":
      return "Cancelled";
    default:
      return status;
  }
};
  

  return (
    <>
      <div className="flex justify-between items-center mb-3">
        <h2 className="md:text-[24px] text-[18px]  text-black">Recent Order</h2>
        <button
          className={`text-xl text-textcolor ${orders?.length === 0 ? "cursor-not-allowed" : "cursor-pointer hover:text-gray-900"} `}
          onClick={() => navigate("/orders-management")}
          disabled={orders?.length === 0 }
        >
          see all
        </button>
      </div>
      <div className="bg-white overflow-hidden border main-shadow border-gray-200 rounded-xl">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Created On
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Order ID
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Advertiser Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Club/ Resort Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading && (
                <tr>
                  <td colSpan={6}>
                    <div className="flex justify-center my-5">
                      <CommonLoader size="md" />
                    </div>
                  </td>
                </tr>
              )}
              {orders.length === 0 && !loading && (
                <tr>
                  <td
                    colSpan="6"
                    className="px-6 py-3 text-sm font-normal text-textcolor"
                  >
                    <div className="flex justify-center items-center mt-5">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2 text-center">No data found</p>
                  </td>
                </tr>
              )}
              {orders.map((order, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-base text-textcolor">
                    {formatTimestamp(order.createdAt )|| "-"}
                  </td>
                  <td className="px-6 py-4 text-base text-textcolor">
                    {order.id ? `#${order.id}` : "-"}
                  </td>
                  <td className="px-6 py-4 text-base text-textcolor">
                    {order.user.name || "-"}
                  </td>
                  <td className="px-6 py-4 text-base text-textcolor">
                    {order.club.clubName || "-"}
                  </td>
                  <td className="px-6 py-4 text-base text-textcolor">
                    {order.subscriptionDuration === 1
                      ? order.subscriptionDuration + " Month"
                      : order.subscriptionDuration + " Months"}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <span
                      className={`font-medium ${getStatusColor(order.statusColor)}`}
                    >
                      {getOrderStatus(order.orderStatus) || "-"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default RecentOrders;
